import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="flex flex-col rounded-2xl bg-ivory p-6" data-id="element-20" data-mp="2o64z023bcjug">
      <span className="self-start rounded px-2 py-0.5 font-display text-[11px] font-black uppercase tracking-wider text-white" style={{
      backgroundColor: bonus.color
    }} data-id="element-21" data-mp="2t4gbkkkzt8gd">
        Bonus {bonus.number}
      </span>
      <h3 className="mt-3 min-h-[3.2rem] font-display text-lg font-black uppercase leading-tight text-charcoal" data-id="element-22" data-mp="20cd5d5jw2fth">
        {bonus.name}
      </h3>
      <p className="mt-2 text-sm font-semibold leading-snug text-forest" data-id="element-23" data-mp="29ew2ra4wo08c">{bonus.headline}</p>
      <ul className="mt-4 flex-1 space-y-1.5 text-sm text-charcoal/85" data-id="element-24" data-mp="2e6e788650iy2">
        {bonus.items.map(item => <li key={item} className="flex gap-2" data-id="element-25" data-mp="1hmx0y753237s">
            <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-26" data-mp="1hm5g9rd0xpwa" />
            {item}
          </li>)}
      </ul>
      <div className="mt-5 flex items-center justify-between gap-3 border-t border-charcoal/10 pt-4" data-id="element-27" data-mp="1x2eeti8m4qxb">
        <s className="text-base font-black text-charcoal/60 decoration-red-600 decoration-2" data-id="element-28" data-mp="1s43475ahuce1">
          ${bonus.value} USD
        </s>
        <span className="rounded-md bg-forest px-3 py-1.5 font-display text-xs font-black uppercase text-ivory" data-id="element-29" data-mp="1nah3mbhltyyl">
          Free today
        </span>
      </div>
    </article>;
}